// 示例数据，供开发时使用
export const sampleUsers = [
  { id: 'u1', name: 'alice' },
  { id: 'u2', name: 'bob' },
];

export const samplePosts = [
  {
    id: 'p1',
    title: '欢迎来到我的博客',
    content: '这是第一篇示例文章。你可以在这里写 Markdown 内容。',
    authorId: 'u1',
    authorName: 'alice',
    createdAt: Date.now() - 1000 * 60 * 60 * 24,
  },
  {
    id: 'p2',
    title: '第二篇文章示例',
    content: '示例内容：使用本地存储保存文章，支持编辑和删除。',
    authorId: 'u2',
    authorName: 'bob',
    createdAt: Date.now() - 1000 * 60 * 60 * 48,
  },
];

export const aboutInfo = {
  title: '关于本站',
  content: '这是一个基于 React + antd 的示例博客，数据保存在 localStorage 中。',
};
